import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { deleteThirdParty } from '@/modules/ThirdParty/gql/third-party.gql'
import { SnackType } from '@/interfaces/snack'
import { ThirdParty } from '@/modules/ThirdParty/interfaces/third-party'
import ThirdPartyForm from '@/modules/ThirdParty/components/ThirdPartyForm.vue'
import { showErrors, showNotification } from '@/utils/snack'

@Component({
  components: {
    AppDialog,
    ThirdPartyForm,
    AppTextSearch
  }
})
export default class ThirdPartyDialog extends Vue {
  targetThirdParty: ThirdParty | null = null

  ThirdPartyDialog = {
    show: false,
    title: 'New Third Party',
    disable: false,
    actionType: 'new',
    highlightTitle: ''
  }

  deleteThirdPartyDialog = {
    show: false,
    title: 'Delete Third Party',
    disable: false
  }

  showThirdPartyDialog (e: Event, targetThirdParty?: ThirdParty) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Third Party : '
    let highlightTitle = ''
    if (targetThirdParty) {
      this.targetThirdParty = targetThirdParty
      actionType = 'edit'
      title = 'Edit Third Party : '
    }
    this.ThirdPartyDialog = {
      actionType,
      show: true,
      title,
      disable: false,
      highlightTitle
    }
  }

  hideThirdPartyDialog () {
    this.targetThirdParty = null
    this.ThirdPartyDialog = {
      actionType: 'new',
      show: false,
      title: 'New Third Party',
      disable: false,
      highlightTitle: ''
    }
  }

  async deleteThirdParty (e: Event, targetThirdParty: ThirdParty) {
    e.preventDefault()
    e.stopPropagation()
    this.targetThirdParty = targetThirdParty
    this.deleteThirdPartyDialog.show = true
  }

  async deleteThirdPartyPost () {
    if (!this.targetThirdParty) {
      return
    }
    const { id } = this.targetThirdParty
    this.deleteThirdPartyDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteThirdParty,
        variables: {
          thirdPartyId: Number(id)
        }
      })

      const res = result.data.deleteThirdParty
      if (res) {
        showNotification({
          msg: 'Delete third party successfully',
          type: SnackType.Success
        })
        this.targetThirdParty = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
